import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { ThemePalette } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';


export const confirmDeleteDataGenerator = (
  title: string,
  objectType: string,
  objectName: string,
) => {
  return {
    title: `${title}`,
    message: `Are you sure you want to delete the ${objectType}, '${objectName}'?`,
    button1: {
      label: 'Delete',
      icon: 'delete',
      result: true,
      matColor: 'warn',
    },
    button2: {
      label: 'Cancel',
      result: false,
      focusInitial: true,
    },
  };
};

export const confirmDeleteSchedulerAssignment = () => {
  return {
    title: 'Delete Assignment?',
    message: 'Are you sure you want to delete Assignment?',
    button1: {
      label: 'Yes',
      icon: 'delete',
      result: true,
      matColor: 'warn',
    },
    button2: {
      label: 'Cancel',
      result: false,
      focusInitial: true,
      matColor: 'primary',
    },
  };
};

export const confirmDeleteSchedulerJob = () => {
  return {
    title: 'Delete Job?',
    message: 'Are you sure you want to delete Job?',
    button1: {
      label: 'Yes',
      icon: 'delete',
      result: true,
      matColor: 'warn',
    },
    button2: {
      label: 'Cancel',
      result: false,
      focusInitial: true,
      matColor: 'primary',
    },
  };
};

export const confirmOutsideNormalWorkHours = (type: string) => {
  return {
    title: 'Outside of Normal Work Hours',
    message: 'Are you sure you want to set ' + type + ' outside of normal work hours?',
    button1: {
      label: 'Yes',
      icon: 'check',
      result: true,
    },
    button2: {
      label: 'Cancel',
      result: false,
      focusInitial: true,
    },
  };
};

export const confirmConflictingEstimatedMixers = (
  maxMixersScheduled: number,
  maxMixers: number,
) => {
  return {
    title: 'There is a conflict with Estimated mixers',
    message: `Are you sure you want to schedule this job at this time? The estimated number of mixers needed for all jobs during this time is ${maxMixersScheduled} and will exceed the available ${maxMixers} mixer limit. (${maxMixersScheduled}/${maxMixers})`,
    button1: {
      label: 'Yes',
      icon: 'check',
      matColor: 'warn',
      result: true,
    },
    button2: {
      label: 'Cancel',
      result: false,
      focusInitial: true,
    },
  };
};

export const confirmNavigateWithUnsavedChanges = () => {
  return {
    title: 'Unsaved Changes',
    message:
      'You have unsaved changes on this page.  Are you sure you want to leave this page before saving them?',
    button1: {
      label: 'Leave',
      result: true,
      matColor: 'warn',
    },
    button2: {
      label: 'Stay',
      result: false,
      focusInitial: true,
    },
  };
};

export const promptLoadExistingData = (filename: string) => {
  return {
    title: 'Load Existing Data?',
    message: `Would you like to continue existing import of "${filename}"? (Starting over cannot be undone)`,
    button1: {
      label: 'Yes',
      result: true,
      matColor: 'primary',
    },
    button2: {
      label: 'Start Over',
      result: false,
      matColor: 'warn',
    },
  };
};

export const promptLoadExistingFormData = () => {
  return {
    title: 'Keep Existing Data?',
    message: 'Previously unsaved data was recovered for this form. Would you like to continue? (Starting over cannot be undone)',
    button1: {
      label: 'Yes',
      result: true,
      matColor: 'primary',
    },
    button2: {
      label: 'Start Over',
      result: false,
      matColor: 'warn',
    },
  };
};

export interface ConfirmDialogData {
  title: string,
  message: string,
  /**
   * Printed below the message in an accented color
   */
  warningMessage?: string,
  warningMessages?: string[],
  button1: {
    label: string,
    icon?: string,
    matColor?: ThemePalette,
    result: any,
    focusInitial?: boolean,
  };
  button2?: {
    label: 'Cancel' | 'No',
    icon?: string,
    matColor?: ThemePalette,
    result: any,
    focusInitial?: boolean,
  };
}

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatIcon
]
})
export class ConfirmDialogComponent {
  data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);
}
